module.exports = __webpack_public_path__ + "img/ume_banner.b23058d2.png";